import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { useCallback, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import NumberInput from 'src/components/NumberInput';
import useViewBudgetPeriod from 'src/hooks/useViewBudgetPeriod';
import { getBgColor } from 'src/utils/icons';

const AmountCell = (props: GridCellProps) => {
  const { distributionType, isReadOnly, poDetails } = useViewBudgetPeriod();

  const { field, dataIndex, dataItem, onChange } = props;

  const handleChange = useCallback(
    (e: TextBoxChangeEvent) => {
      onChange?.({
        dataIndex,
        dataItem,
        syntheticEvent: e.syntheticEvent,
        field,
        value:
          e.value === '.' || e.value === '' || !e.value
            ? e.value
            : Number(poDetails?.poTotal) < 0
            ? Math.abs(Number(e.value)) * -1
            : Math.abs(Number(e.value)),
      });
    },
    [dataIndex, dataItem, field, onChange, poDetails?.poTotal]
  );
  const { displayValue, value } = useGridCellDisplayValue(props);

  const error: string[] = useMemo(() => dataItem?.errors?.amount, [dataItem?.errors?.amount]);

  if (isReadOnly || distributionType !== 'Amount') {
    return (
      <GridCellBase {...props} title={`${displayValue}`}>
        <p className="text-right">{displayValue}</p>
      </GridCellBase>
    );
  }

  return (
    <GridCellBase {...props} title={`${displayValue}`} className={getBgColor(error)}>
      <NumberInput value={value} onChange={handleChange} prefix="$" valid={!error?.length} />
    </GridCellBase>
  );
};

export default AmountCell;
